module.exports = __webpack_public_path__ + "img/task.61b5cded.svg";